import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classnames from "classnames";
import SiniaCustomChart from "../../components/charts/sinia-custom-chart.component";
import ProgressBar from "components/progress-bar/progress-bar.component";
import { DataService } from "../../services/data.service";
import ChartUtils from "../../commons/chart-utils.module";
import IndicadoresAmbientales from "../../commons/indicadores.module";
import Ubigeo from "../../commons/ubigeo.module";
import FichaLista from "../vista-estadisticas/ficha-lista";
import ListaData from "../vista-estadisticas/ficha-data";
import FichaInfo from "../vista-estadisticas/ficha-info";
import { Series } from "highcharts";
const NUM_INDICADORES_A_CARGAR = false;
class BloqueGraficos extends React.Component {
  static propTypes = {
    idRegion: PropTypes.string,
    idTematica: PropTypes.string,
    inlineCharts: PropTypes.number
  };
  static defaultProps = {
    inlineCharts: 12
  };
  constructor(props) {
    super(props);
    let me = this;
    me.chartRefs = {};
    me.indicadores = [];
    me.lastIdTematica = me.props.idTematica;
    me.loadingMode = true;
    this.state = {
      indicadores_store: [],
      indicadores_store_info: [],
      activeTab: "1",
      currentItem: {},
      data_estadistica: [],
      data_ficha:[],
      idRegion:undefined
    };
    this.checkItemsChange = this.checkItemsChange.bind(this);
  }
  cargarIndicadores(idTematica) {
    this.indicadores = IndicadoresAmbientales.getIdsIndicadoresPorTematica(
      idTematica,
      NUM_INDICADORES_A_CARGAR
    );
    this.noDataToShow = !this.indicadores.length;
  }
  crearReferencias() {
    let me = this;
    me.indicadores.forEach(idIndicador => {
      let refId = "ref" + idIndicador;
      if (!me.chartRefs[refId]) {
        me.chartRefs[refId] = React.createRef();
      }
    });
  }
  crearNuevasReferencias(idIndicador) {
    let me=this;
    let refId = "ref" + idIndicador.id;
    if (!me.chartRefs[refId]) {
      me.chartRefs[refId] = React.createRef();
    }
  }
  componentDidMount() {
  }
  componentDidUpdate(prevProps) {
    let me = this,props = this.props;
    if (
      prevProps.idRegion !== props.idRegion ||
      prevProps.idTematica !== props.idTematica ||
      prevProps.availableStore!==props.availableStore
    ) {
      me.cargarDatos();
    }
  }
  cargarDatos() {
     let me = this,
      props = me.props;
    let data_indicadores = [];
    let indicador_source = IndicadoresAmbientales.getIndicadoresPorTematica(
      props.idTematica
      );
      for (const key in indicador_source) {
        const object = indicador_source[key];
        const element = object;
        data_indicadores.push(element);
      }

      if(me.state.idRegion){
        if(me.state.idRegion!==props.idRegion){
          me.setState(
            {
              indicadores_store: data_indicadores,
              idRegion:props.idRegion
            },
            () => me.checkItemsChange(me.state.currentItem)
          );
        }else{
          me.setState(
            {
              indicadores_store: data_indicadores,
              idRegion:props.idRegion
            },
            () => me.checkItemsChange(data_indicadores[0])
          );
        }
      }else{
        me.setState(
          {
            indicadores_store: data_indicadores,
            idRegion:props.idRegion
          },
          () => me.checkItemsChange(data_indicadores[0])
        );
      }
  }

  tabToggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  checkItemsChange(event) {
    let me = this,props = me.props;
    if (event) {
      let idIndicador = IndicadoresAmbientales.get(event.id);
      me.crearNuevasReferencias(idIndicador);
      me.setState({ currentItem: idIndicador }, () =>
        me._cargarDatosDeGrafico(idIndicador.id, props.idRegion, props.idTematica)
      );
    } else {
      me.setState({ currentItem: {} });
    }
  }

  render() {
    let me = this;
    const {
      indicadores_store,
      indicadores_store_info,
      currentItem,
      data_estadistica,
      data_ficha
    } = this.state;
    me.cargarIndicadores(me.props.idTematica);
    if (me.noDataToShow) {
      return me.renderNoData();
    }
    return (
      <Row>
          <Col className="md-12">
            <Card className="card-border-line">
              <CardBody>
                <Row className="no-gutters">
                  <Col xs={12} sm={4} md={4} xl={4}>
                    <FichaLista
                      title="Indicadores disponibles"
                      items={indicadores_store}
                      onChange={this.checkItemsChange}
                    />
                  </Col>
                  <Col xs={12} sm={8} md={8} xl={8}>
                    <CardBody>
                      <Nav tabs>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: this.state.activeTab === "1",
                            })}
                            onClick={() => {
                              this.tabToggle("1");
                            }}
                          >
                            Gráfico
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: this.state.activeTab === "2",
                            })}
                            onClick={() => {
                              this.tabToggle("2");
                            }}
                          >
                            Datos
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: this.state.activeTab === "3",
                            })}
                            onClick={() => {
                              this.tabToggle("3");
                            }}
                          >
                            Ficha de divulgación
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                          <Row>
                            <Col sm={12}>
                              {Object.keys(currentItem).length > 0 ? (
                                <div className="charts-container-section">
                                  {me.renderChart(currentItem.id, "line")}
                                </div>
                              ) : (
                                <div></div>
                              )}
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="2">
                          <Row>
                            <Col sm={12}>
                              <ListaData ambito={me.props.idRegion} info={currentItem} items={data_estadistica} />
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="3">
                          <Row>
                            <Col>
                             <FichaInfo items={data_ficha} />
                            </Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
    );
    {/*return (
      <div>
          {me.indicadores.map(function (idIndicador) {
            return me.renderChart(idIndicador);
          })}
      </div>
        );*/}
  }
  renderNoData() {
    return (
      <div className="alert alert-info sinia-message" role="alert">
        Lo sentimos, no disponemos de información sobre la temática
        seleccionada.
      </div>
    );
  }
  /**
   * Es renderizado cuando los datos están cargando
   */
  renderLoading() {
    return <ProgressBar active={true} />;
  }
  /**
   *
   * @param {string} idIndicador
   * @param {RefObject} referencia
   */
  renderChart(idIndicador, type = "column") {
    let me=this;
    let regionNombre=Ubigeo.getNombreRegion(me.state.idRegion);
    let titleTpl = ` ${regionNombre}: ${IndicadoresAmbientales.getNombre(
      idIndicador
    )}`;
    let { inlineCharts } = this.props;
    return (
      <div key={idIndicador}>
        <SiniaCustomChart 
          exportable={true}
          key={idIndicador}
          chartType={type}
          titleTpl={titleTpl}
          yAxeTitle={IndicadoresAmbientales.getUnidad(idIndicador)}
          seriesLabel={IndicadoresAmbientales.getUnidad(idIndicador)}
          xAxeTitle="Años"
          source={`Fuente: ${IndicadoresAmbientales.getFuenteAbrev(
            idIndicador
          )}`}
          ref={this.chartRefs["ref" + idIndicador]}
        />
      </div>
    );
  }
  _cargarDatosDeGrafico(idIndicador, idRegion, idTematica) {
    var me = this;
    let idSerie=IndicadoresAmbientales.getSerie(idIndicador, idRegion);
    if(idSerie){
      DataService.getData(
        {
          query: "SNA08",
          ubigeo: idRegion,
          marco: idTematica,
          serie: idSerie
        },
        function (data) {
          if (data.SNA08.data && data.SNA08.data[0] && data.SNA08.data[0].valor) {
            me.formatServerResponseDataAndUpateCharts(
              idIndicador,
              data.SNA08.data
            );
            me.setState({
              data_estadistica: data.SNA08.data
            });
          } else {
            me.formatServerResponseDataAndUpateCharts(idIndicador, []);
            me.setState({
              data_estadistica: []
            });
          }
        }
      );
    }else{
      me.setState({
        data_estadistica: []
      });
    }
    me._cargarDatosDeFicha(idIndicador);
  }

  _cargarDatosDeFicha(indicador){
    let me=this;
    DataService.getData(
      {
        query: "ANA10",
        serie: indicador
      },
      function (data) {
        if (data.ANA10.data) {
          me.setState({
            data_ficha: data.ANA10.data
          });
        } else {
          me.setState({
            data_ficha: []
          });
        }
      }
    );
  }

  /**
   * Formatear respuesta del servidor y actualizar gráficos.
   *
   * @param {string|number} idIndicador
   * @param {array} rawData Datos en formato de respuesta del servidor
   * Ejm:
   * [
   *   {periodo: 2010, ubigeo: '25', valor: 2587, nombre: 'Ucayali'},
   *   ...
   * ]
   */
  formatServerResponseDataAndUpateCharts(idIndicador, rawData) {
    let me = this,
      data = ChartUtils.formatYearlyDataForChart(rawData);
      me.actualizarDatosDeGrafico(me.getChart(idIndicador), idIndicador, data);
  }
  getChart(idIndicador) {
    return this.chartRefs["ref" + idIndicador].current;
  }
  /**
   *
   * @param {SiniaCustomChart} chart
   * @param {Object} datos
   * @param {Array} data.valores
   * @param {Array} data.categorias
   */
  actualizarDatosDeGrafico(chart, idIndicador, datos) {
    let me=this;
    if (!chart) {
      return;
    }
    chart.actualizarDatos(datos.valores, datos.categorias, {
      region: Ubigeo.getNombreRegion(this.props.idRegion),
      anioInicio: datos.anioInicio,
      anioFin: datos.anioFin,
      unidad: IndicadoresAmbientales.getUnidad(idIndicador)
    });
  }
}
export default BloqueGraficos;
